import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, watch } from 'vue';
import { renderAsync } from 'docx-preview';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'FilePreviewDocx' },
  __name: 'FilePreviewDocx',
  props: { src: Blob, documentHeight: { type: String, default: '700px' } },
  setup(__props) {

const props = __props;

const refDocxPreviewElement = ref<HTMLDivElement>();
const refStyleContainer = ref<HTMLDivElement>();

watch(
  () => props.src,
  () => {
    renderWord();
  }
);

const renderWord = async () => {
  if (!refDocxPreviewElement.value || !refStyleContainer.value) {
    console.warn('Preview elements not initialized yet');
    return;
  }
  await renderAsync(props.src, refDocxPreviewElement.value, refStyleContainer.value);
};

onMounted(() => {
  renderWord();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(`box-sizing: content-box; overflow: scroll; height: ${__props.documentHeight}`)
  }, [
    _createElementVNode("div", {
      ref_key: "refDocxPreviewElement",
      ref: refDocxPreviewElement
    }, null, 512),
    _createElementVNode("div", {
      ref_key: "refStyleContainer",
      ref: refStyleContainer
    }, null, 512)
  ], 4))
}
}

})